var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00D5FF"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "87.445,45.582 59.991,45.582 55.765,47.521 54.642,54.314 95,54.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.465,45.582 5,45.582 11.96,54.314 30.591,54.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.537,54.528 39.774,51.065 40.209,45.811 48.587,41.101 53.396,35.745 68.07,36.242    75.594,44.634 66.088,44.636 59.844,44.763 54.755,47.276 53.371,55.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.49,37.907 41.726,35.159 29.653,41.952 31.342,55.549 42.145,63.874 60.267,64.883    74.597,55.173 60.262,55.249 53.866,56.579 43.71,55.33 39.034,51.138 39.158,45.582 47.872,40.766  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnot);
export default __webpack_public_path__ + "static/media/knot.db974ab1.svg";
export { ForwardRef as ReactComponent };